function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
  x: 153.6,
  y: 153.6,
  width: 204.8,
  height: 204.8
})));

var _ref3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  d: "M486.4,281.6c15.36,0,25.6-10.24,25.6-25.6c0-12.8-10.24-25.6-25.6-25.6h-25.6v-51.2h25.6c15.36,0,25.6-10.24,25.6-25.6 c0-12.8-10.24-25.6-25.6-25.6h-25.6v-25.6c0-28.16-23.04-51.2-51.2-51.2H384V25.6C384,12.8,373.76,0,358.4,0 c-12.8,0-25.6,10.24-25.6,25.6v25.6h-51.2V25.6C281.6,12.8,271.36,0,256,0s-25.6,10.24-25.6,25.6v25.6h-51.2V25.6 c0-12.8-10.24-25.6-25.6-25.6C138.24,0,128,10.24,128,25.6v25.6h-25.6c-28.16,0-51.2,23.04-51.2,51.2V128H25.6 C10.24,128,0,138.24,0,153.6c0,12.8,10.24,25.6,25.6,25.6h25.6v51.2H25.6C10.24,230.4,0,240.64,0,256c0,12.8,10.24,25.6,25.6,25.6 h25.6v51.2H25.6C10.24,332.8,0,343.04,0,358.4C0,371.2,10.24,384,25.6,384h25.6v25.6c0,28.16,23.04,51.2,51.2,51.2H128v25.6 c0,12.8,10.24,25.6,25.6,25.6c15.36,0,25.6-10.24,25.6-25.6v-25.6h51.2v25.6c0,12.8,10.24,25.6,25.6,25.6s25.6-10.24,25.6-25.6 v-25.6h51.2v25.6c0,12.8,10.24,25.6,25.6,25.6c12.8,0,25.6-10.24,25.6-25.6v-25.6h25.6c28.16,0,51.2-23.04,51.2-51.2V384h25.6 c15.36,0,25.6-10.24,25.6-25.6c0-12.8-10.24-25.6-25.6-25.6h-25.6v-51.2H486.4z M409.6,409.6H102.4V102.4h307.2V409.6z"
})));

var _ref4 = /*#__PURE__*/React.createElement("g", null);

var _ref5 = /*#__PURE__*/React.createElement("g", null);

var _ref6 = /*#__PURE__*/React.createElement("g", null);

var _ref7 = /*#__PURE__*/React.createElement("g", null);

var _ref8 = /*#__PURE__*/React.createElement("g", null);

var _ref9 = /*#__PURE__*/React.createElement("g", null);

var _ref10 = /*#__PURE__*/React.createElement("g", null);

var _ref11 = /*#__PURE__*/React.createElement("g", null);

var _ref12 = /*#__PURE__*/React.createElement("g", null);

var _ref13 = /*#__PURE__*/React.createElement("g", null);

var _ref14 = /*#__PURE__*/React.createElement("g", null);

var _ref15 = /*#__PURE__*/React.createElement("g", null);

var _ref16 = /*#__PURE__*/React.createElement("g", null);

var _ref17 = /*#__PURE__*/React.createElement("g", null);

var _ref18 = /*#__PURE__*/React.createElement("g", null);

var SvgRam = function SvgRam(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16, _ref17, _ref18);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgRam, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/ram.dd2261c0.svg";
export { ForwardRef as ReactComponent };